import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Events.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/exhibitions',
    name: 'Exhibitions',
    component: () => import('../views/Events.vue'),
  },
  {
    path: '/exhibitions/:slug',
    name: 'Event',
    component: () => import('../views/Event.vue'),
    props: true,
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: "auto" };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
